/** Sentinel used by the API for the "no value" column (no priority, no assignee). */
export const BOARD_UNASSIGNED_VALUE = "unassigned";

/** Synthetic column holding every task with a `DONE` status. */
export const BOARD_COMPLETE_COLUMN_KEY = "complete";

export const BOARD_COLUMN_PAGE_SIZE = 5;

/** Quiet time after the last sort click before the cards reload and save. */
export const BOARD_SORT_COMMIT_DELAY_MS = 300;

export const BOARD_COLUMN_WIDTH = 300;

export const BOARD_COLLAPSED_COLUMN_WIDTH = 48;

/**
 * Drags start only after a specified number of pixels dragged,
 * so the plain click never turns into a drag.
 */
export const BOARD_DRAG_ACTIVATION_DISTANCE_PX = 8;

/**
 * Off-screen paint skip (`content-visibility: auto`). `auto` in the intrinsic
 * size remembers the last real height so the scrollbar does not jump.
 */
export const BOARD_CARD_CONTENT_VISIBILITY = {
  contentVisibility: "auto",
  containIntrinsicSize: "auto 160px",
} as const;

export const BOARD_COLUMN_CONTENT_VISIBILITY = {
  contentVisibility: "auto",
  containIntrinsicSize: `${BOARD_COLUMN_WIDTH}px auto`,
} as const;

export const BOARD_COLLAPSED_COLUMN_CONTENT_VISIBILITY = {
  contentVisibility: "auto",
  containIntrinsicSize: `${BOARD_COLLAPSED_COLUMN_WIDTH}px auto`,
} as const;

export const BOARD_GROUP_BY_STORAGE_KEY = "tasks-board-group-by";
